"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UICardSection = _interopRequireDefault(require("../card/UICardSection"));

var _UIAccordionItem = _interopRequireDefault(require("../accordion/UIAccordionItem"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _AbstractTextElement = _interopRequireDefault(require("../elements/AbstractTextElement"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var legacySizes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var titleSizes = ['extra-small', 'small', 'medium', 'large', 'extra-large'];
var headingForSize = {
  'extra-small': 'span',
  small: 'h5',
  medium: 'h4',
  large: 'h2',
  'extra-large': 'h1'
};

var isLegacyTitleSize = function isLegacyTitleSize(prop) {
  return legacySizes.includes(prop);
};

var renderTitle = function renderTitle(title, titleSize, isExpander, expanded, onExpandedChange) {
  var isLegacy = isLegacyTitleSize(titleSize);

  if (isLegacy) {
    _devLogger.default.warn({
      message: 'UICardHeader: the `titleSize` prop now takes t-shirt sizes ' + ' (`small`, `medium`, `large`) instead of `h1`-`h6`',
      key: 'UIAccordionItem: use size prop'
    });
  }

  if (isExpander === true) {
    return _react.default.createElement(_UIAccordionItem.default, {
      className: "private-card__title",
      onOpenChange: onExpandedChange,
      open: expanded,
      title: title,
      size: isLegacy ? undefined : titleSize,
      textElement: isLegacy ? titleSize : undefined
    });
  }

  return _react.default.createElement(_AbstractTextElement.default, {
    className: "private-card__title",
    tagName: isLegacy ? titleSize : headingForSize[titleSize]
  }, title);
};

var _default = _react.default.createClass({
  displayName: "UICardHeader",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UICardSection.default.propTypes, ['children']), {
    expanded: _react.PropTypes.bool.isRequired,
    onExpandedChange: _react.PropTypes.func,
    title: _react.PropTypes.node,
    titleSize: _react.PropTypes.oneOf([].concat(legacySizes, titleSizes)),
    toolbar: _react.PropTypes.node
  }),
  getDefaultProps: function getDefaultProps() {
    return {
      expanded: true,
      titleSize: 'medium'
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        expanded = _this$props.expanded,
        onExpandedChange = _this$props.onExpandedChange,
        title = _this$props.title,
        titleSize = _this$props.titleSize,
        toolbar = _this$props.toolbar,
        other = (0, _objectWithoutProperties2.default)(_this$props, ["className", "expanded", "onExpandedChange", "title", "titleSize", "toolbar"]);
    var isExpander = typeof onExpandedChange === 'function';
    var classes = (0, _classNames.default)('private-card__header', className, {
      'private-card__header--with-toolbar': !!toolbar,
      'private-card__header--expandable': isExpander === true
    });
    return _react.default.createElement(_UICardSection.default, (0, _extends2.default)({
      className: classes
    }, other), _react.default.createElement(_UIFlex.default, {
      align: "start",
      justify: "between"
    }, renderTitle(title, titleSize, isExpander, expanded, onExpandedChange), toolbar && expanded ? _react.default.createElement("div", {
      className: "private-card__toolbar"
    }, toolbar) : null));
  }
});

exports.default = _default;
module.exports = exports.default;